export const DESTINATION_TYPES = {
  COUNTRY: 'country',
  REGION: 'region',
  CITY: 'city',
}

export type DestinationType = (typeof DESTINATION_TYPES)[keyof typeof DESTINATION_TYPES]
